export const contactDetails = {
    phoneDisplay: "+91 77997 11997",
    phoneHref: "tel:+917799711997",
    email: "support@zozojobs.com",
    emailHref: "mailto:support@zozojobs.com",
    location: "Head Office Tirupati",
};
